import React from 'react'
import { Box, Typography } from '@mui/material'
import TileShell, { tileValueSx } from './TileShell'
import { statusColor } from './tileColors'

const clampPercent = (value) => Math.min(100, Math.max(0, Number(value) || 0))

const GaugeTile = ({ kpi }) => {
  const na = kpi.na || kpi.status === 'na'
  const colors = statusColor(kpi.status)
  const reference =
    kpi.numerator !== undefined && kpi.denominator !== undefined && !na
      ? `${kpi.numerator}/${kpi.denominator} · target ${kpi.reverse ? '≤' : '≥'} ${kpi.target}%`
      : `Target ${kpi.reverse ? '≤' : '≥'} ${kpi.target}%`

  return (
    <TileShell
      dotColor={na ? undefined : colors.main}
      label={kpi.label}
      sublabel={reference}
      description={kpi.description}
    >
      {na ? (
        <Typography sx={{ ...tileValueSx, color: 'text.disabled' }}>N/A</Typography>
      ) : (
        <>
          <Typography sx={{ ...tileValueSx, color: colors.main }}>{kpi.percent}%</Typography>
          {/* Progress towards 100% with a tick at the target */}
          <Box
            sx={{
              position: 'relative',
              height: 6,
              my: 0.75,
              borderRadius: 3,
              bgcolor: `${colors.main}26`,
            }}
          >
            <Box
              sx={{
                width: `${clampPercent(kpi.percent)}%`,
                height: '100%',
                borderRadius: 3,
                bgcolor: colors.main,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                left: `${clampPercent(kpi.target)}%`,
                top: -3,
                bottom: -3,
                width: 2,
                ml: '-1px',
                borderRadius: 1,
                bgcolor: 'text.primary',
              }}
            />
          </Box>
        </>
      )}
    </TileShell>
  )
}

export default GaugeTile
